// TODO variant b (весь файл)
import React, { memo, useCallback, useMemo } from 'react';

import { Card as DsCard, Space, Typography, Icon } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';

import { IBlockPropsVariantB } from './BigBlock';
import styles from './blocks.module.scss';

export const Card = memo<IBlockPropsVariantB>(({ item, handleClick, darkTheme, isMobile }) => {
  const cx = useStyles(styles);
  const textWrapperClassNames = cx({
    textWrapper: item.picture,
  });

  const innerPicture = useMemo(
    () => (darkTheme && item.pictureForDarkTheme ? item.pictureForDarkTheme : item.picture),
    [darkTheme, item.picture, item.pictureForDarkTheme],
  );

  const handleCardClick = useCallback(() => {
    handleClick(item.pageUrl);
  }, [item, handleClick]);

  return (
    <DsCard size={16} className={styles.card} onClick={handleCardClick} color="dark">
      <div className={styles.cardContainer}>
        <Space direction="vertical" justify="space-between">
          <Space className={textWrapperClassNames} direction="vertical" size={4}>
            {item.title && (
              <Typography.Heading level={6} className={styles.cardTitle}>
                {item.title}
              </Typography.Heading>
            )}
            {item.subtitle && (
              <Typography.Text size={12} className={styles.cardSubtitle}>
                {item.subtitle}
              </Typography.Text>
            )}
          </Space>
          <Space className={styles.iconWrapper} justify={item.badge ? 'space-between' : 'end'} align="center">
            {item.badge && item.badge}
            {item.icon && <Icon icon={item.icon} size={isMobile ? 24 : 28} />}
          </Space>
        </Space>
        {innerPicture && (
          <div className={styles.pictureContainer}>
            <picture>{innerPicture}</picture>
          </div>
        )}
      </div>
    </DsCard>
  );
});
